import { useEffect } from 'react';
import {
  useSelector,
  useDispatch,
  shallowEqual,
  batch,
} from 'react-redux';
import {
  selectAllValidBoothIds,
  selectBoothIdIndex,
  fetchBoothById,
  BoothFetchedLevel,
  fetchMoreMetaBooths,
} from 'models/cms/booths';

const useFetchSurroundingBoothsEffect = (boothId: string) => {
  const dispatch = useDispatch();
  const boothIds = useSelector(selectAllValidBoothIds, shallowEqual);
  const boothIndex = useSelector(selectBoothIdIndex(boothId), shallowEqual);

  useEffect(() => {
    batch(() => {
      const range = 1;
      [
        ...boothIds.slice(Math.max(0, boothIndex - range), boothIndex),
        ...boothIds.slice(boothIndex + 1, boothIndex + 1 + range),
      ]
        .forEach((id) => dispatch(fetchBoothById({ boothId: id, expectedLevel: BoothFetchedLevel.Details })));
      if (boothIndex > -1 && boothIndex + 2 >= boothIds.length) {
        dispatch(fetchMoreMetaBooths());
      }
    });
  }, [boothId, boothIds, boothIndex, dispatch]);
};

export default useFetchSurroundingBoothsEffect;
